export enum StorageLocation {
  TOKEN = "token",
}

export class Storage {
  public static readonly Set = (location: StorageLocation, value: string) => localStorage.setItem(location, value);
  public static readonly Clear = (location: StorageLocation) => localStorage.removeItem(location);
  public static readonly Get = (location: StorageLocation) => localStorage.getItem(location);
}
